export const TEN_SECONDS = 10000;
export const FIVE_SECONDS = 5000;

export const ONE_HOUR = 1000 * 60 * 60;
export const ONE_DAY = ONE_HOUR * 24;
